export default "__VITE_ASSET__83e66ada__"